/**
 * Component that initializes Capacitor deep link handling
 * Must be rendered inside a Router context to access navigation
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { initDeepLinkListener } from '../utils/capacitorDeepLinks';

export function CapacitorDeepLinkHandler(): null {
  const navigate = useNavigate();

  useEffect(() => {
    initDeepLinkListener(navigate);
  }, [navigate]);

  return null;
}
